import SecondaryCTA from './SecondaryCTA';

export default SecondaryCTA;
